<template>
    <div class="block">
        <el-dialog
        title="编辑真实性"
        :visible.sync="dialogVisible"
        width="20%"
        center>
            <br>
            <el-form ref="form" :model="form" :rules="rules">
                <el-form-item label="真实性：" prop="leads_status">
                    <ClueStatus ref="ClueStatus" v-model="form.leads_status" :status="parseInt(form.leads_status)" :status_child="parseInt(form.leads_status_child)" :check_strictly="false" :is_edit="true" @change="statusHandleChange"></ClueStatus>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('form')" :loading="loading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
  </template>
  <script>
  import ContactService from "~/services/contact";
  import ClueStatus from "~/widgets/ClueStatus.vue";
  import Config from "~/config/params";
  export default {
    name: "contactDialog",
    components: {
        ClueStatus
    },
    props: {
        // 线索记录模型
        contact: {
            type: Object,
            default: null,
            required: true
        }
    },
  
    data() {
      return {
        dialogVisible: false,
        loading: false,
        form: {
            leads_status: this.contact.leads_status,
            leads_status_child: this.contact.leads_status_child,
        },
        rules: {
            leads_status: [
                {
                    required: true,
                    message: "请选择真实性"
                }
            ]
        },
      };
    },
  
    created() {
    },
  
    mounted() {
  
    },
    methods: {
        statusHandleChange(value){
            if(value && value.length > 0){
                this.form.leads_status = value[0];
                this.form.leads_status_child = value.length > 1 ? value[1] : '';
            }else{
                this.form.leads_status = '';
                this.form.leads_status_child = '';
            }
        },

        show(){
            this.dialogVisible = true;
        },

        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if(valid) {
                    this.changeLeadStatus();
                } else {
                    return false;
                }
            })
        },

        changeLeadStatus() {
            this.loading = true;
            var contact = _.clone(this.contact);
            // contact['qq'] = contact.qq > 0 ? contact.qq : '';
            // contact['products'] = this.contact.products && this.contact.products.length > 0 ? this.contact.products.map(item => item.product_id) : [];
            // contact['leads_status'] = this.form.leads_status;
            // contact['leads_status_child'] = this.form.leads_status_child;
            this.form['id'] = this.contact.id;
            ContactService.changeLeadStatus(this.form).then(res => {
                if (res.code == 0) {
                    this.$message.success('修改成功');
                    this.$emit("change", this.form);
                    this.dialogVisible = false;
                }
                this.loading = false;
            }).catch(err => {
                console.error(err);
            })
        },
    },
  };
  </script>
  
  


// WEBPACK FOOTER //
// src/views/customer/dialog/contactDialog.vue